import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            anotherLastName: '',
            anotherName: '',
            anotherPatronymic: '',
            telephone: '',
            email: '',
        }
    },
    getters: {
        anotherLastName(state){
            return state.anotherLastName;
        },
        anotherName(state){
            return state.anotherName;
        },
        anotherPatronymic(state){
            return state.anotherPatronymic;
        },
        telephone(state){
            return state.telephone;
        },
        email(state){
            return state.email;
        },
    },
    mutations: {
        [mns.SET_ANOTHER_LAST_NAME](state, value){
            state.anotherLastName = value;
        },
        [mns.SET_ANOTHER_NAME](state, value){
            state.anotherName = value;
        },
        [mns.SET_ANOTHER_PATRONYMIC](state, value){
            state.anotherPatronymic = value;
        },
        [mns.SET_TELEPHONE](state, value){
            state.telephone = value;
        },
        [mns.SET_EMAIL](state, value){
            state.email = value;
        },
    }
} // export.